import React, { Component } from 'react';
import Translator from '../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import Submain from '../../../components/home-page-sub-content/submain';
import { Redirect } from 'react-router-dom';
import { Common } from '../../../core/common';
import { ActivityType } from '../../../models/enums/ActivityType';

const T = Translator.create();
const _logger = Log.create('ProgramAdmin/Main.tsx');
let _common: Common;

export class ProgramAdminCockpit extends React.Component<any> {
    state = {
        goToStorageManagementPage: false,
        goToOrganizastionChartPage: false,
        goToMasterCoursePage: false,
        goToTermPage: false,
        goToCoursePage: false,
        goToUserPage: false,
    };

    constructor(props: any) {
        _common = new Common();
        super(props);
    }

    public render() {
        if (this.state.goToStorageManagementPage) {
        } else if (this.state.goToMasterCoursePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-master-course'} />
        } else if (this.state.goToCoursePage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-course'} />
        } else if (this.state.goToUserPage) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/u/admin-user'} />
        }

        return (
            <div >
                <div className="student-course">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12">
                                <div className="d-flex justify-content-between student-course-header pd-top-30">
                                    <div>
                                        <h2 style={{ color: '#323231', fontSize: '20px' }}>{T.t('r_gen_administration_panel')}</h2>
                                    </div>
                                </div>
                                <ul className="student-course-list list-unstyled mt-4">
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onClick={() => this.setState({ goToMasterCoursePage: true })}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#e7e4ee' }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#006279' }}>collections_bookmark </i>
                                                </div>
                                                <div className="list-content d-inline-block mx-2">
                                                    <h5 className="mt-1 mb-0 text-start" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_gen_main_courses')}
                                                    </h5>
                                                    <p>{T.t('r_gen_course_catalogs_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_main_course')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onClick={() => this.setState({ goToCoursePage: true })}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#d9f0ff' }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#006279' }}>book </i>
                                                </div>
                                                <div className="list-content d-inline-block mx-2 ">
                                                    <h5 className="mt-1 mb-0  text-start" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_gen_courses')}
                                                    </h5>
                                                    <p>{T.t('r_gen_course_content_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_course')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{ display: 'block' }} key={'reports-row-3'}>
                                        <div
                                            className="row"
                                            style={{ margin: '10px 5px', cursor: 'pointer' }}
                                            onClick={() => this.setState({ goToUserPage: true })}
                                        >
                                            <div className="col-md-9 align-self-center">
                                                <div className="report-row-image" style={{ backgroundColor: '#e2f4eb' }}>
                                                    <i className="material-icons report-row-icon" style={{ color: '#3d8f6a' }}>group </i>
                                                </div>
                                                <div className="list-content d-inline-block mx-2">
                                                    <h5 className="mt-1 mb-0  text-start" style={{ marginBottom: 2.5 }}>
                                                        {T.t('r_gen_users')}
                                                    </h5>
                                                    <p>{T.t('r_gen_system_users_management')}</p>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex align-items-center justify-content-end">
                                                <span className="badge badge-secondary report-row-badge text-uppercase">
                                                    {T.t('r_gen_user')}
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}